module.exports = __webpack_public_path__ + "img/Identity-Pattern2.f19a40a0.jpg";